<template>
    <section class="section is-relative">
        <b-table
            :data="tableData"
            :loading="isLoading"

            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="false"
            pagination-position="bottom"
            default-sort-direction="asc"
            sort-icon="chevron-up"
            sort-icon-size="is-small"



            :backend-pagination="true"

            :total="total"
            paginated
            striped
            narrowed
            hoverable
            focusable

            :default-sort="sortBy"
            :default-sort-direction="sortDirection"
            aria-next-label="Следующая страница"
            aria-previous-label="Предыдущая страница"
            aria-page-label="Страница"
            aria-current-label="Текущая страница"

            @click="onTableClick"
        >
            <b-table-column cell-class="is-clickable" field="date" label="Дата" :th-attrs="dateThAttrs"  :td-attrs="columnTdAttrs" centered v-slot="props">
                {{ props.row.startedAt | datetime }}
            </b-table-column>

            <b-table-column cell-class="is-clickable" field="mode" label="Режим" :th-attrs="dateThAttrs" :td-attrs="columnTdAttrs" centered v-slot="props">
                {{ props.row.modeTranslate }}
            </b-table-column>

            <b-table-column cell-class="is-clickable" field="positionId" label="Должность" :th-attrs="dateThAttrs" :td-attrs="columnTdAttrs" centered v-slot="props">
                {{ $_get(props.row, 'position.name', '...')}}
            </b-table-column>

            <b-table-column cell-class="is-clickable" field="ticket.title" label="Билет" :th-attrs="dateThAttrs"  :td-attrs="columnTdAttrs" centered v-slot="props">
                {{ $_get(props.row, 'ticket.title', '...')}}
            </b-table-column>

            <b-table-column cell-class="is-clickable" field="ticket.questionsAmount" label="Всего вопросов" :th-attrs="dateThAttrs" :td-attrs="columnTdAttrs" centered v-slot="props">
                {{ props.row.ticket.questionsAmount }}
            </b-table-column>

            <b-table-column cell-class="is-clickable" field="rightAnswersCount" label="Правильных ответов" :th-attrs="dateThAttrs" :td-attrs="columnTdAttrs" centered v-slot="props">
                {{ props.row.rightAnswersCount }}
            </b-table-column>

            <b-table-column cell-class="is-clickable" field="result" label="Результат" :th-attrs="dateThAttrs" :td-attrs="columnTdAttrs" centered v-slot="props">
                <!--                <rate-icon :rate="props.row.calculatedRate" />-->
                <rate-text :rate="props.row.calculatedRate" />
            </b-table-column>

            <template #bottom-left>
                <b>Общее количество</b>: {{ total }}
            </template>
        </b-table>

    </section>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { get, map, orderBy } from 'lodash'
import ContextMixin from '../../../../../mixins/ContextMixin'

export default {
    props: {
        userId: {
            required: false,
            type: String
        },
        routeName: {
            required: true,
            type: String
        }
    },
    mixins: [
        ContextMixin,
    ],
    data () {
        return {
            selected: null,
            total: 0,
            currentPage: 1,
            currentIds: [],
            perPage: 10,
            filters: {},
            sortDirection: 'desc',
            sortBy: 'startedAt',
        }
    },
    methods: {
        ...mapActions({
            fetchItems: 'e/tests/fetchFinished',
            addLoader: 'e/pages/addLoader',
            removeLoader: 'e/pages/removeLoader',
        }),
        dateThAttrs(column) {
            switch (column.field) {
                case 'date':
                    return {title: 'Дата и время начала теста'}
                default:
                    return null
            }
        },
        columnTdAttrs(row, column) {
            switch (column.field) {
                case 'date':
                    return {title: row.startedAt}
                case 'result':
                    const rate = row.calculatedRate
                    return {title: rate}
                default:
                    return null
            }
        },
        onTableClick(row) {
            this.$router.push({name: this.routeName, params: {testId: row.id}})
        },
        fetch() {
            let params = {
                CurrentPage: this.currentPage,
                Status: this.statusByTab,
                PerPage: this.perPage,
                SortDirection: this.sortDirection,
                SortBy: 'createdAt',
            }
            if (this.userId) params['UserId'] = this.userId
            for (let i in this.filters) {
                switch (i) {
                    case 'mode':
                        params['Mode'] = this.filters[i]
                        break;
                }
            }
            let sortBy = ''

            switch (this.sortBy) {
                case 'mode':
                    sortBy = 'Mode'
                    break;
                default:
                    sortBy = 'startedAt'
                    break;
            }
            params['SortBy'] = sortBy

            this.fetchItems(params).then((data)=>{
                this.total = get(data, 'meta.total')
                this.currentIds = map(get(data, 'data'), 'id')
            })
        },
        contextChangedHandler() {
            this.fetch()
        }
    },
    created () {
        this.fetch()
    },
    computed: {
        ...mapGetters({
            testsQuery: 'e/tests/query',
            isLoaderActive: 'e/pages/isLoaderActive',
        }),
        tests() {
            return this.testsQuery().with(['ticket', 'questions.options', 'position']).where('finishedAt', value => value !== null).findIn(this.currentIds)
        },
        isLoading () {
            return this.isLoaderActive('tests.fetchItems')
        },
        tableData () {
            return this.tests
        },
    },
    watch: {
        currentPage () {
            this.fetch()
        },
    }
}
</script>
